<template>
  <div>
    <h2>Login with Single Sign-On</h2>
    <form>
      <text-input
        :auto-focus="true"
        :value="email"
        placeholder="johnsmith@example.com"
        label="SSO Email address"
        name="email"
        type="email"
        :error="!isValidEmail"
        validation-message="A valid email is required"
        @input="email = $event"
        @enter="onEnter"
      />
      <div class="flex flex-column justify-content-start align-items-center">
        <loading-button
          :disabled="!isValidEmail"
          :loading="loading"
          @click="login"
        >
          Login
        </loading-button>
        <or-divider />
        <router-link
          class="btn btn-secondary mt-0"
          :to="{
            name: 'login',
            query: { redirectUrl: $route.query.redirectUrl },
          }"
        >
          Sign in with email & password
        </router-link>
      </div>
    </form>
    <div class="footnote">
      <small>
        Don't have an account? Contact sales@inscribe.ai for a demo.
      </small>
    </div>
  </div>
</template>

<script>
import { LoadingButton, OrDivider, TextInput } from '@inscribe/ui-kit';
import { isValidEmail } from '../utils/validation';
import { LOCAL_STORAGE_REDIRECT_URL } from '../constants/login';

export default {
  components: {
    'loading-button': LoadingButton,
    'or-divider': OrDivider,
    'text-input': TextInput,
  },
  data() {
    return {
      email: '',
      loading: false,
    };
  },
  computed: {
    isValidEmail() {
      return isValidEmail(this.email);
    },
  },
  mounted() {
    if (this.$route.query.redirectUrl) {
      localStorage.setItem(
        LOCAL_STORAGE_REDIRECT_URL,
        this.$route.query.redirectUrl,
      );
    }
  },
  methods: {
    onEnter(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      setTimeout(() => {
        this.login();
      });
    },
    login() {
      if (this.isValidEmail) {
        const data = new FormData();
        data.append('email', this.email);
        this.loading = true;
        this.$store
          .dispatch('samlLogin', data)
          .then((response) => {
            this.loading = false;
            window.location.href = response.data.idp_url;
          })
          .catch((error) => {
            this.loading = false;
            this.$notify({
              group: 'general',
              type: 'error',
              title: 'Error logging in',
              duration: 5000,
              text: error.response.data.message,
            });
          });
      }
    },
  },
};
</script>

<style scoped></style>
